import { Component, Input } from '@angular/core';
import { AccessDirectories } from 'src/app/interfaces/access-diretories';
import { SharedDirectory } from 'src/app/interfaces/shared-directory';
import { SharedDirectoryService } from 'src/app/services/api/shared-directory.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-share-directory',
    templateUrl: './share-directory.component.html',
    styleUrls: ['./share-directory.component.scss']
})

export class ShareDirectoryComponent {

    public errorMessageShared: string = '';
    public errorTypeShared: string = '';

    public errorMessageAccess: string = '';
    public errorTypeAccess: string = '';

    @Input() sharedDirectory: SharedDirectory[] = [];
    @Input() accessDirectory: AccessDirectories | undefined;

    constructor(private sharedDirectoryService: SharedDirectoryService,
                public userService: UserService,
                public loader: LoadingService) {
    }

    delete(share: any): void {
      this.resetErrorMessages();
        this.sharedDirectoryService.remove(share.uuid).subscribe((res) => {
            if (res.result == "SUCCESS") {
                const index = this.sharedDirectory?.indexOf(share);
                if (index != -1) {
                    this.sharedDirectory?.splice(index,1);
                }
            } else {
                this.errorTypeShared = res.result;
                this.errorMessageShared = res.content;
            }
        });
    }

    add(mail: string): void {
      this.resetErrorMessages();
        this.sharedDirectoryService.add(mail).subscribe((res) => {
            if (res.result == "SUCCESS") {
                this.sharedDirectory.push(res.content);
            } else {
                this.errorTypeShared = res.result;
                this.errorMessageShared = res.content;
            }
        });
    }

    private resetErrorMessages(): void {
      this.errorMessageShared = '';
      this.errorTypeShared = '';
      this.errorMessageAccess = '';
      this.errorTypeAccess = '';
  }

}
